import { configureStore} from '@reduxjs/toolkit'
import {
  FLUSH,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  REHYDRATE,
  persistReducer,
  persistStore,
} from 'redux-persist'
import storageSession from 'redux-persist/lib/storage/session'
import rootReducer from './rootReducer'
import { perfCountAction, perfActionOrigin } from './modules/perfTrace'
import { setAutoFreeze } from 'immer'

// Redux Toolkit は既定で state を deep freeze する。
// この画面群は entrydataRef など store に渡したオブジェクトを ref で保持し続けるため、
// 凍結されると以降の書き込みが TypeError になる。あわせて入力のたびに
// 巨大な entrydata を全走査するコストも掛かるため無効化する。
setAutoFreeze(false)

// 同一ドメインに複数環境(/kkaplite, /kkaplite_st 等)を配置した場合に、
// 同一タブ内で環境を移動しても永続化stateが混ざらないよう、キーを配置パスで分離する
const persistBaseElement = document.getElementsByTagName('base')[0]
const persistMountPath = persistBaseElement
  ? new URL(persistBaseElement.href).pathname
  : '/'

const persistConfig = {
  key: persistMountPath === '/' ? 'root' : `root@${persistMountPath}`,
  storage: storageSession,
  whitelist: ['user', 'menu', 'env'],
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // 開発時のみ動く整合性チェック。dispatch ごとに state 全体を走査するため重い。
      // 本番ビルドでは元々無効なので、無効化しても本番の挙動は変わらない。
      immutableCheck: false,
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        ignoredActionPaths: [
          'payload.doApply',
          'payload.datedoApply',
          'payload.gridApi',
        ],
        ignoredPaths: [
          'search.doApply',
          'search.datedoApply',
          'search.gridApi',
          'tagsearch.doApply',
        ],
      },
    }).concat(() => (next: any) => (action: any) => {
      // 計測用: action の発生回数を数えるだけ。挙動は変えない。
      perfCountAction(action && action.type);
      const actionType = action && action.type;
      if (actionType === 'form/entrydata' || actionType === 'form/entryrerender' || actionType === 'form/modify') {
        perfActionOrigin(actionType, new Error().stack);
      }
      return next(action);
    }),
})

export type AppDispatch = typeof store.dispatch

export const persistor = persistStore(store)

export default store
